import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import UniformHeight from '@elem/ui/eco-uniform-height';
import FormatCurrencyLocal from 'eco-design-reliance/currency/FormatCurrencyLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Tabs from '../Tabs';
import styles from './index.module.scss';

const ProductList: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('ProductList');

    const tabs = [
        {
            tabLabel: t('tab1_title'),
            tabValue: t('tab1_title'),
            items: [
                {
                    // img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/ecoflow-stream-ultra-x-1183190545.png?v=1754382890',
                    img: '',
                    hoverImg: {
                        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761545616188-yw3853-compressed-Frame%20128721080.jpg',
                        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761545743791-9syfum-compressed-Frame%202094654489.jpg',
                    },
                    title: t('tab1_item1_title'),
                    variantId: {
                        eu: '51787034558807',
                        uk: '51787034558807',
                        de: '57020101296509',
                        fr: '51408465002843',
                        es: '51408468836699',
                        it: '55289474253176',
                    },
                    params: [
                        {
                            name: t('tab1_item1_param1'),
                            value: t('tab1_item1_name1'),
                        },

                        {
                            name: t('tab1_item1_param3'),
                            value: t('tab1_item1_name3'),
                        },
                        {
                            name: t('tab1_item1_param2'),
                            value: t('tab1_item1_name2'),
                        },
                    ],
                    price: 0,
                    compareAtPrice: 0,
                    learnMore: t('tab1_item1_btn'),
                    link_more: '',
                },
                {
                    // img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/ecoflow-stream-ultra-x-1183190545.png?v=1754382890',
                    img: '',
                    hoverImg: {
                        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761545629477-o9x3z4-compressed-Frame%202094654485.jpg',
                        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761545843764-glblqq-compressed-Frame%202094654490.jpg',
                    },
                    title: t('tab1_item2_title'),
                    variantId: {
                        eu: '51787034460503',
                        uk: '51787034460503',
                        de: '57020101198205',
                        fr: '51408464904539',
                        es: '51408468738395',
                        it: '55289474154872',
                    },
                    params: [
                        {
                            name: t('tab1_item2_param1'),
                            value: t('tab1_item2_name1'),
                        },

                        {
                            name: t('tab1_item2_param3'),
                            value: t('tab1_item2_name3'),
                        },
                        {
                            name: t('tab1_item2_param2'),
                            value: t('tab1_item2_name2'),
                        },
                    ],
                    price: 0,
                    compareAtPrice: 0,
                    learnMore: t('tab1_item2_btn'),
                    link_more: '',
                },
            ],
        },
        {
            tabLabel: t('tab2_title'),
            tabValue: t('tab2_title'),
            items: [
                {
                    // img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/ecoflow-stream-ultra-x-1183190545.png?v=1754382890',
                    img: '',
                    hoverImg: {
                        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761545642959-qz854m-compressed-Frame%202094654486.jpg',
                        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761545872464-f5atsf-compressed-Frame%202094654415.jpg',
                    },
                    title: t('tab2_item1_title'),
                    variantId: {
                        eu: '51787034624343',
                        uk: '51787034624343',
                        de: '57020101329277',
                        fr: '51408465035611',
                        es: '51408468869467',
                        it: '55289474285944',
                    },
                    params: [
                        {
                            name: t('tab2_item1_param1'),
                            value: t('tab2_item1_name1'),
                        },

                        {
                            name: t('tab2_item1_param3'),
                            value: t('tab2_item1_name3'),
                        },
                        {
                            name: t('tab2_item1_param2'),
                            value: t('tab2_item1_name2'),
                        },
                    ],
                    price: 0,
                    compareAtPrice: 0,
                    learnMore: t('tab2_item1_btn'),
                    link_more: '',
                },
                {
                    // img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/ecoflow-stream-ultra-x-1183190545.png?v=1754382890',
                    img: '',
                    hoverImg: {
                        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761545665308-b1mw8z-compressed-Frame%202094654487.jpg',
                        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761545895673-5r7e74-compressed-Frame%202094654491.jpg',
                    },
                    title: t('tab2_item2_title'),
                    variantId: {
                        eu: '51787034526039',
                        uk: '51787034526039',
                        de: '57020101230973',
                        fr: '51408464937307',
                        es: '51408468771163',
                        it: '55289474187640',
                    },
                    params: [
                        {
                            name: t('tab2_item2_param1'),
                            value: t('tab2_item2_name1'),
                        },

                        {
                            name: t('tab2_item2_param3'),
                            value: t('tab2_item2_name3'),
                        },
                        {
                            name: t('tab2_item2_param2'),
                            value: t('tab2_item2_name2'),
                        },
                    ],
                    price: 0,
                    compareAtPrice: 0,
                    learnMore: t('tab2_item2_btn'),
                    link_more: '',
                },
            ],
        },
        {
            tabLabel: t('tab3_title'),
            tabValue: t('tab3_title'),
            items: [
                {
                    // img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/ecoflow-stream-ultra-x-1183190545.png?v=1754382890',
                    img: '',
                    hoverImg: {
                        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761545675089-jfnurp-compressed-Frame%202094654488.jpg',
                        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761545911865-rlifvd-compressed-Frame%202094654492.jpg',
                    },
                    title: t('tab3_item1_title'),
                    variantId: {
                        eu: '51787034591575',
                        uk: '51787034591575',
                        de: '57020101362045',
                        fr: '51874296758619',
                        es: '51408468902235',
                        it: '55289474318712',
                    },
                    params: [
                        {
                            name: t('tab3_item1_param1'),
                            value: t('tab3_item1_name1'),
                        },

                        {
                            name: t('tab3_item1_param2'),
                            value: t('tab3_item1_name2'),
                        },
                    ],
                    price: 0,
                    compareAtPrice: 0,
                    learnMore: t('tab3_item1_btn'),
                    link_more: '',
                },
            ],
        },
    ];

    const [responsiveTabs, setResponsiveTabs] = useState(tabs);

    async function getItemInfo() {
        // const variantIds = tabs.map((tab) => tab.items.map((item) => item.variantId));
        const variantIds = tabs.flatMap((tab) => tab.items.map((item) => item.variantId[locale as keyof typeof item.variantId]));

        const res = await getSolarRecommand2({ variantIds }, locale);
        if (res.code === '0') {
            // 找到对应的 item, 然后替换
            const newTabs = cloneDeep(tabs);
            newTabs.forEach((tab) => {
                tab.items.forEach((item) => {
                    const newItem = res.data.find((_item: any) => _item.variantId === item.variantId[locale as keyof typeof item.variantId]);
                    if (newItem) {
                        item.img = newItem.variantImg;
                        item.price = newItem.price;
                        item.compareAtPrice = newItem.compareAtPrice;
                        item.title = newItem.skuTitle;
                        item.link_more = `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=${newItem.variantId}`;
                    }
                });
            });
            setResponsiveTabs(newTabs);

            console.log(res.data, newTabs);
        }
    }

    useEffect(() => {
        getItemInfo();
    }, []);

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className={`${styles.ProductList} product-list GtmModuleData-section`} data-section-id="d3m-productlist">
            <div className="d3m-tabs">
                <Tabs className="product-list-tabs" tabs={responsiveTabs} activeIndex={activeIndex} onChange={(_, index) => setActiveIndex(index)} />
            </div>
            <ul className="swipers">
                {responsiveTabs.map((tab, m) => (
                    <li className={`swiper-box swiper-box-${m} swiper-box-${m}${activeIndex === m ? ' active' : ''}`} key={m}>
                        <UniformHeight
                            targets={[
                                { selector: '.item-title', groupId: `titles-${m}`, minHeight: 20 },
                                { selector: '.item-subs', groupId: `params-${m}`, minHeight: 20 },
                            ]}
                            minHeight={20}
                            enabled={activeIndex === m}
                            refreshTrigger={responsiveTabs}
                        >
                            <Swiper
                                className="items"
                                breakpoints={{ 1024: { spaceBetween: 24 }, 375: { spaceBetween: 16 } }}
                                slidesPerView={'auto'}
                                initialSlide={0}
                            >
                                {tab.items.map((item: any, k: number) => (
                                    <SwiperSlide className={`item item-${k + 1}`} key={`${m}_${k}`}>
                                        <div className="item-img">
                                            <EcoImg className="img-p" pc={item.img} key={item.img} isOpenLazy={true} />
                                            <EcoImg className="img-h" pc={item.hoverImg?.pc} h5={item.hoverImg?.h5} isOpenLazy={true} />
                                        </div>
                                        <div className="item-info">
                                            <div className="item-common">
                                                <p className="item-title" data-uniform-target>
                                                    {item.title}
                                                </p>
                                                {/* <p className="item-desc">{item.desc}</p> */}
                                                <ul className="item-subs" data-uniform-target>
                                                    {item.params?.map((sub: any, n: number) => (
                                                        <>
                                                            <li className="item-sub" key={`${m}_${k}_${n}`}>
                                                                <p className="item-sub-name">{sub.name}</p>
                                                                <p className="item-sub-text">{sub.value}</p>
                                                            </li>
                                                            {n < item.params.length - 1 && <li className="item-sub-divider"></li>}
                                                        </>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div className="item-action">
                                                <div className="item-price">
                                                    {item?.price > 0 && (
                                                        <span className="price-price">
                                                            {FormatCurrencyLocal(item.price, locale, false, locale === 'eu' ? ',' : undefined)}
                                                        </span>
                                                    )}
                                                    {item?.price > 0 && item?.compareAtPrice && item?.price !== item?.compareAtPrice && (
                                                        <span className="price-compare">
                                                            {FormatCurrencyLocal(item.compareAtPrice, locale, false, locale === 'eu' ? ',' : undefined)}
                                                        </span>
                                                    )}
                                                </div>
                                                <EcoLink
                                                    className={`item-link GtmModuleData-btn-href item-${m}_${k + 1}`}
                                                    href={item?.link_more}
                                                    dataLayer={{
                                                        event: 'uaEvent',
                                                        event_name: 'buy',
                                                        product_name: item?.title,
                                                        position: `Product Detail_STREAM Ultra Series_`,
                                                        __btn_id1: `product-list .item-${m}_${k + 1}`,
                                                        __btn_id2: item?.link_more || '',
                                                        __btn_type: 'href',
                                                    }}
                                                >
                                                    {item?.learnMore}
                                                </EcoLink>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </UniformHeight>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProductList;
